__turbopack_context__.v({
  "overlay": "full-screen-loading-module-scss-module__D97vNW__overlay",
});
